import { colors } from '../../../styles'

const QuestionMark = ({ height = 10 }) => {
  return (
    <svg
      viewBox="332.913 272.021 54.336 94.962"
      height={height}
      fill={colors.darkGray}
    >
      <g transform="matrix(1, 0, 0, 1, 310.113159, 269.582703)">
        <path d="M76.7,24.8c-1.9-11-10.9-20-21.9-21.9c-8.1-1.5-16.2,0.7-22.3,5.9c-6.2,5.2-9.7,12.8-9.7,20.8c0,3.8,3.1,6.8,6.8,6.8     c3.8,0,6.8-3,6.8-6.8c0-4,1.8-7.8,4.8-10.4c3.1-2.6,7.1-3.6,11.2-2.9c5.3,0.9,9.9,5.5,10.8,10.8c1.4,7.7-3.6,13.6-9.1,15.4     c-6.6,2.1-11,8.3-11,15.5v8.7c0,3.8,3.1,6.8,6.8,6.8c3.8,0,6.8-3,6.8-6.8V58c0-1.2,0.7-2.2,1.6-2.5     C71.4,51.3,79.1,38.4,76.7,24.8z" />
        <path d="M50,80.2c-4.8,0-8.6,3.9-8.6,8.6c0,4.8,3.9,8.6,8.6,8.6c4.8,0,8.6-3.9,8.6-8.6C58.7,84.1,54.8,80.2,50,80.2z" />
      </g>
    </svg>
  )
}

export default QuestionMark
